import React from 'react'
import './StateBanner.css'

function cx(...parts) {
  return parts.filter(Boolean).join(' ')
}

export default function EmptyHero({
  eyebrow,
  headline,
  body,
  actions = [],
  decoration,
  className = '',
}) {
  const visibleActions = actions.slice(0, 2)

  return (
    <section className={cx('empty-hero', decoration && 'empty-hero--with-decoration', className)}>
      <div className="empty-hero__content">
        {eyebrow && <div className="empty-hero__eyebrow">{eyebrow}</div>}
        <h2 className="empty-hero__headline">{headline}</h2>
        {body && <div className="empty-hero__body">{body}</div>}

        {visibleActions.length > 0 && (
          <div className="empty-hero__actions">
            {visibleActions.map((action) => (
              <button
                type="button"
                key={action.label}
                className={cx(
                  'empty-hero__action',
                  action.kind === 'secondary' ? 'empty-hero__action--secondary' : 'empty-hero__action--primary'
                )}
                onClick={action.onClick}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {decoration && <div className="empty-hero__decoration">{decoration}</div>}
    </section>
  )
}
